import React from 'react';
import classnames from 'classnames';
import useTerminology from '@sift/skipper/helpers/useTerminology';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import SlideContent from './SlideContent';
import AttributePageIcon from 'components/Icons/AttributePage';
import IndependentPageIcon from 'components/Icons/IndependentPage';

interface Props {
  classes: any;
  onSetOpen: (status: boolean) => void;
  setSlideIndex: (slideIndex: number) => void;
}

function ChoosePageTypeSlide({ classes, onSetOpen, setSlideIndex }: Props) {
  const terminology = useTerminology();

  return (
    <SlideContent
      renderCloseIcon={true}
      slideTitle="Which would you like to add?"
      onSetOpen={onSetOpen}
      setSlideIndex={setSlideIndex}
    >
      <div className={classes.row}>
        <Card
          data-testid="attribute-card"
          classes={{ root: classes.paper }}
          className={classnames(classes.card, classes.marginRight3)}
          onClick={() => setSlideIndex(1)}
        >
          <CardContent className={classes.cardContent}>
            <AttributePageIcon className={classes.cardImage} />
            <Typography className={classes.marginBottom2} variant="h6">
              Attribute Pages
            </Typography>
            <Typography variant="body2">
              Create pages that will be associated to {terminology.plural} in Sift. These pages will
              be linked to from your {terminology.singular} profile pages, and page editors or data
              sync will be able to manage people that are associated to each page.
            </Typography>
          </CardContent>
        </Card>
        <Card
          data-testid="independent-card"
          classes={{ root: classes.paper }}
          className={classes.card}
          onClick={() => setSlideIndex(2)}
        >
          <CardContent className={classes.cardContent}>
            <IndependentPageIcon className={classes.cardImage} />
            <Typography className={classes.marginBottom2} variant="h6">
              Independent Pages
            </Typography>
            <Typography variant="body2">
              Create pages that are not associated to {terminology.plural}. These pages will only be
              accessible from Sift search and will not include members.
            </Typography>
          </CardContent>
        </Card>
      </div>
    </SlideContent>
  );
}

export default ChoosePageTypeSlide;
